import React, {useEffect} from 'react';
import TimelineVJ from './TimelineVJ'

export default function TimelineMain() {
   useEffect(()=>{
      window.scrollTo(0,0)
      },[]) 

  return (
    <div>
    <div>
      <TimelineVJ />  
    </div>
    </div>
  )
}
